import { useEffect, useState } from "react";
import { useHospital } from "../../../components/HospitalContext";
import useCasesCount from "../../../hooks/useCasesCount";
import StaffApi from "../../../api/staff";
import { useNavigate } from "react-router-dom";

export function usePanel({}) {
  const navigate = useNavigate();

  const [search, setSearch] = useState({
    patientStatus: "all",
    myCases: true,
  });

  const [staffInfoloading, setStaffInfoLoading] = useState(true);
  const [staffMemberInfo, setStaffMemberInfo] = useState(null);
  const { casesCount, fetch: refetchCasesCount } = useCasesCount(search.myCases);

  const logout = () => {
    // localStorage.clear();
    sessionStorage.clear();
    const hospital = JSON.parse(localStorage.getItem("hospital") || "null");
    const hospitalName = hospital?.name?.toLowerCase() || "gi";
    navigate(`/Login/${hospitalName}`, { replace: true });
  }

  // Fetch staff member info
  useEffect(() => {
    StaffApi.getStaffMember()
      .then((staffInfo) => {
        setStaffMemberInfo(staffInfo);
      })
      .finally(() => setStaffInfoLoading(false));
  }, []);

  return {
    search,
    setSearch,
    staffMemberInfo,
    staffInfoloading,
    casesCount,
    refetchCasesCount,
    logout
  };
}
